module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-chofer-gris.adecca7b.svg";